<div class="crm-container">
  <div class="sub-sec">
    <div class="sub-sec-header">
      <div class="title">
        <div>Covered Products</div>
      </div>
      <div *ngIf="canAdd">
        <div class="three-dots" (click)="ellipsisClick($event,'item',opHeader,null)">
          <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
        </div>
      </div>
    </div>
    <p-toast position="top-right" styleClass="covered-products-toast"></p-toast>
  </div>
  <div class="covered-products-column-picker multi-select">
    <p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
      selectedItemsLabel="{0} columns selected" defaultLabel="Choose Columns" appendTo="body"
      styleClass="covered-products-column-multiselect" (onChange)="onColumnChange()"
      (onPanelHide)="onColumnPickerPanelHide()">
    </p-multiSelect>
  </div>
  <div class="covered-products-table-scroll">
  <p-table [columns]="selectedColumns" [value]="coveredProduts" dataKey="productsId" editMode="row"
    [loading]="isLoading" styleClass="p-datatable-gridlines covered-products-datatable">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [ngClass]="'col-' + col.field">{{col.header}}</th>
        <th class="last-cell" [ngClass]="{ 'row-edit' : isEditing }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing" let-ri="rowIndex">
      <tr [pEditableRow]="rowData">
        <td *ngFor="let col of columns" [ngClass]="'col-' + col.field">
          <p-cellEditor [style.font-weight]="col.font">
            <ng-template pTemplate="input">
              <input class="input-text" *ngIf="col.type === 'text' && permissionsCols[col.label]" type="text"
                [(ngModel)]="rowData[col.field]" />
              <input class="input-text" *ngIf="col.type === 'text' && !permissionsCols[col.label]" type="text"
                [(ngModel)]="rowData[col.field]" disabled="disabled" />
              <input *ngIf="col.type === 'checkbox'" type="checkbox" [(ngModel)]="rowData[col.field]" /><input
                *ngIf="col.type === 'date' && permissionsCols[col.label]" type="date"
                [(ngModel)]="rowData[col.field]"
                [max]="col.field === 'productPurchaseDate' ? maxPurchaseDate : null" />
              <input *ngIf="col.type === 'date' && !permissionsCols[col.label]" type="date"
                [(ngModel)]="rowData[col.field]" disabled="disabled" />
              <p-select *ngIf="col.type === 'select' && col.field === 'subcategoryDescription'"
                [options]="subcategoryOptions" [filter]="true" placeholder="Select"
                (onChange)="onDropDownChange($event, ri)" optionLabel="value" appendTo="body">
              </p-select>
              <p-select *ngIf="col.type === 'select' && col.field !== 'subcategoryDescription'"
                [options]="dropdown[col.field]" [(ngModel)]="rowData[col.field]" appendTo="body">
              </p-select>
              <div *ngIf="col.type === 'id' || col.type === 'disabled'">
                {{rowData[col.field]}}
              </div>
            </ng-template>
            <ng-template *ngIf="col.type !== 'checkbox'" pTemplate="output">{{rowData[col.field]}}</ng-template>
            <ng-template *ngIf="col.type === 'checkbox'" pTemplate="output">
              <input type="checkbox" [(ngModel)]="rowData[col.field]" disabled="disabled" /></ng-template>
          </p-cellEditor>
        </td>
        <td class="last-cell" [ngClass]="{ 'row-edit': editing }">
          <div *ngIf="!editing && canEdit">
            <div class="three-dots" (click)="ellipsisClick($event,rowData,optionRow,ri)">
              <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
            </div>
          </div>
          <button class="ui-button-info" [style.display]="'none'" id="{{editConstant + rowData['id']}}"
            pButton="pButton" type="button" pInitEditableRow="pInitEditableRow" icon="pi pi-pencil"
            (click)="onRowEditInit(rowData)"></button>
          <div class="row-edit-actions" *ngIf="editing">
            <button class="ui-button-success" pButton="pButton" type="button"
              pSaveEditableRow="pSaveEditableRow" icon="pi pi-check"
              (click)="onRowEditSave(rowData, ri)"></button>
            <button class="ui-button-danger" pButton="pButton" type="button"
              pCancelEditableRow="pCancelEditableRow" icon="pi pi-times"
              (click)="onRowEditCancel(rowData, ri)"></button>
          </div>
        </td>
      </tr>
    </ng-template></p-table>
  </div>
</div>
<p-popover #optionRow>
  <p-listbox [options]="ellipsisRowOptions"
    (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event) : ellipsisOptionClick($event)">
  </p-listbox>
</p-popover>
<p-popover #opHeader>
  <p-listbox [options]="ellipsisHeaderOptions"
    (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event, opHeader) : ellipsisOptionClick($event)">
  </p-listbox>
</p-popover>
<history-item-modal modalTitle="Covered Products History" [(displayDialog)]="displayHistory" [formData]="historyData"
  *ngIf="displayHistory">
</history-item-modal>